export const LANGUAGES_TRANSLATE = {
    languages: {
        breadcrumbName: "Idiomas",
        messages: {
            create: "Linguagem criada com sucesso",
            update: "Linguagem atualizada com sucesso",
            delete: "Linguagem excluída com sucesso",
            recover: "Linguagem recuperada com sucesso"
        },
        list: {
            table: {
                columns: {
                    id: "ID",
                    name: "Nome",
                    tag: "Tag"
                }
            },
            filters: {
                fields: {
                    active: {
                        label: "Situação",
                        placeholder: "Selecione a situação",
                        url: "situacao"
                    }
                }
            },
            dialog: {
                delete: {
                    title: "Inativar linguagem",
                    body: "Tem certeza que deseja inativar a linguagem com o ID {{id}}?",
                    save: { text: "Sim, inativar" },
                    back: { text: "Voltar" }
                }
            }
        },
        save: {
            form: {
                fields: {
                    name: {
                        label: "Nome",
                        placeholder: "Informe o nome do idioma"
                    },
                    tag: {
                        label: "Tag",
                        placeholder: "Ex: pt-BR"
                    },
                    active: {
                        label: "Ativo"
                    },
                    countryFlag: {
                        label: "Ícone da bandeira",
                        noResultsLabel: "Nenhuma imagem selecionada",
                        noResultsDescription: "Clique para selecionar uma imagem da bandeira",
                        textButton: "Selecionar imagem",
                        changeTextButton: "Alterar imagem"
                    }
                }
            }
        }
    }
};
